import { Avatar, Separator, Text } from "../../../components";
import { CaretDownIcon, CaretUpIcon } from "../../../components/icons";
import { format } from "date-fns";
import React from "react";
import { AttendeeInfo } from "@repo-sapiens/data-access-models";
import {
  AttendeeCaretIconStyle,
  AttendeeHeaderStyle,
  AttendeeInfoBodyStyle,
  AttendeeLeftStyle,
  AttendeeStyle,
} from "../styles";

type Props = {
  attendee: AttendeeInfo;
  defaultExpanded?: boolean;
};
export const AttendeeCard: React.FC<Props> = ({
  defaultExpanded,
  attendee,
}) => {
  const [expanded, setExpanded] = React.useState(defaultExpanded);
  const onExpand = () => {
    setExpanded(!expanded);
  };
  return (
    <div className={AttendeeStyle(expanded || false)}>
      <div className={AttendeeHeaderStyle} onClick={onExpand}>
        <div className={AttendeeLeftStyle}>
          <Avatar
            src={attendee?.profile_pic_url}
            username={
              attendee?.user_full_name || attendee?.user_email || "unknown"
            }
            size="2"
          />
          <Separator.Vertical spacing={1} />
          <div>
            <Text.BodySM color="primary">
              {attendee?.user_full_name || attendee?.user_email || "unknown"}
            </Text.BodySM>
            <Text.Body2XS color="seconday">
              {attendee?.company_info?.name || "/"}
            </Text.Body2XS>
          </div>
        </div>
        {expanded ? (
          <CaretUpIcon fill="highlight/1" style={AttendeeCaretIconStyle} />
        ) : (
          <CaretDownIcon fill="highlight/1" style={AttendeeCaretIconStyle} />
        )}
      </div>
      <div className={AttendeeInfoBodyStyle}>
        {attendee?.lastInteraction?.date && (
          <Text.Body2XS color="highlight/4">
            Last met on {format(new Date(), "EEEE, dd MMMM")}
          </Text.Body2XS>
        )}
        {!attendee?.confident && (
          <Text.Body2XS color="highlight/5">
            This information is not confirmed. Please double-check.
          </Text.Body2XS>
        )}
        <Separator.Horizontal spacing={2} />
        <AttendeeItemLabel label="Position" value={attendee?.position || "/"} />
        <Separator.Horizontal spacing={2} />

        <AttendeeItemLabel label="Location" value={attendee?.location || "/"} />
        <Separator.Horizontal spacing={2} />

        <AttendeeItemLabel
          label="Career summary"
          value={attendee?.career_summary || "/"}
        />
        <Separator.Horizontal spacing={2} />

        <AttendeeItemLabel
          label="Education Summary"
          value={attendee?.education_summary || "/"}
        />
        <Separator.Horizontal spacing={2} />

        <AttendeeItemLabel label="Other" value={attendee?.fun_fact || "/"} />

        <Separator.Horizontal spacing={2} />
        <AttendeeItemLabel
          label="Linkedin"
          value={attendee?.linkedin_profile}
          link
        />
      </div>
    </div>
  );
};

type AttendeeItemLabelProps = {
  label: string;
  value: string;
  link?: boolean;
};
function AttendeeItemLabel({ label, value, link }: AttendeeItemLabelProps) {
  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <Text.Body2XS color="darkGrey">{label}</Text.Body2XS>
      {(!link || !value) && (
        <Text.BodySM color="primary">{value || "/"}</Text.BodySM>
      )}
      {link && value && (
        <Text.Link href={value} target="_blank" size="body-sm">
          {value}
        </Text.Link>
      )}
    </div>
  );
}
